/**
 * Resolves the portfolio datepicker `disabledBeforeDate`.
 *
 * Prefer API `availableDateRange.startDate` when it is strictly before the analysis end.
 * A snapshot start on or after that end cannot form a period (the period store requires
 * the minimum to be before the end). Using it would leave the placeholder same-day period
 * and block tracks, metrics, and navigation weights. Fall back to the tree later-of start.
 */
export function resolvePortfolioDisabledBeforeDate({
  availableDateRangeStartDate,
  treeDisabledBeforeDate,
  analysisEndDate,
}: {
  availableDateRangeStartDate?: string | null;
  treeDisabledBeforeDate?: string | null;
  /** End date the period store will enforce. ISO `YYYY-MM-DD`. */
  analysisEndDate?: string | null;
}): string | null {
  const canUseAvailableStart =
    !!availableDateRangeStartDate && (!analysisEndDate || availableDateRangeStartDate < analysisEndDate);

  if (canUseAvailableStart) return availableDateRangeStartDate;

  return treeDisabledBeforeDate || null;
}
